import { HttpsUrl } from '../../types/HttpsUrl';
import { ButtonTitle } from '../Button/ButtonTitle';
import { TitleBorder } from '../Parts/TitleBorder';

import styles from './Title.module.scss';

import type { FC } from 'react';

import { assertNever } from '@/packages/nurse-senka-frontend-sdk';

export type Props = {
  type: 'h2' | 'h3' | 'h4';
  title: string;
  link?: HttpsUrl;
  linkText?: string;
};

export const Title: FC<Props> = ({ type, title, link, linkText }) => {
  switch (type) {
    case 'h2':
      return (
        <div className={styles.wrap}>
          <div className={styles['wrap-above']}>
            <h2 className={styles['title-h2']}>{title}</h2>
            {link && <ButtonTitle linkText={linkText} link={link} />}
          </div>

          <TitleBorder />
        </div>
      );
    case 'h3':
      return (
        <div className={styles.wrap}>
          <div className={styles['wrap-above']}>
            <h3 className={styles['title-h3']}>{title}</h3>
            {link && <ButtonTitle linkText={linkText} link={link} />}
          </div>
          <TitleBorder />
        </div>
      );
    case 'h4':
      return <h4 className={styles['title-h4']}>{title}</h4>;
    default:
      return assertNever(type);
  }
};
